// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"MiniTable_headerCell__2BB0j","bodyCell":"MiniTable_bodyCell__KLXST"};